import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';

const CLIENT_FINGERPRINT_STORAGE_NAME = 'ClientFingetprint';

@Injectable({
    providedIn: 'root'
})
export class ClientFingerprintService {
    constructor(private localStorageService: LocalStorageService) { }

    GetClientFingerprint() {
        let clientFingetprint = this.localStorageService.GetItem(CLIENT_FINGERPRINT_STORAGE_NAME);
        if (!clientFingetprint) {
            const clientFingetprintInt = Math.round(Math.random() * 1000000000);
            clientFingetprint = clientFingetprintInt.toString();
            this.localStorageService.SetItem(CLIENT_FINGERPRINT_STORAGE_NAME, clientFingetprint);
        }
        return clientFingetprint;
    }
}
